import { render, staticRenderFns } from "./InfoSimWidget.vue?vue&type=template&id=461d4ec4&scoped=true&"
import script from "./InfoSimWidget.vue?vue&type=script&lang=js&"
export * from "./InfoSimWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d4ec4",
  null
  
)

export default component.exports